/* Mega menu behaviour: hover intent delays, touch guard, keyboard via hidden (D-0332) */
(() => {
  const OPEN_MS = 90;
  const CLOSE_MS = 220;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('[data-drb-nav]').forEach((nav) => {
    if (nav.dataset.drbReady === 'true') return;
    nav.dataset.drbReady = 'true';

    const items = Array.from(nav.querySelectorAll('.drb-nav__item--has-panel'));
    if (!items.length) return;

    let openTimer = null;
    let closeTimer = null;
    let current = null;

    const panelOf = (item) => item.querySelector('[data-drb-nav-panel]');
    const triggerOf = (item) => item.querySelector('[data-drb-nav-trigger]');

    const clearTimers = () => {
      if (openTimer) window.clearTimeout(openTimer);
      if (closeTimer) window.clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    };

    const close = (item) => {
      if (!item) return;
      const panel = panelOf(item);
      const trigger = triggerOf(item);
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (current === item) current = null;
    };

    const closeAll = (except) => {
      items.forEach((i) => {
        if (i !== except) close(i);
      });
    };

    const open = (item) => {
      const panel = panelOf(item);
      const trigger = triggerOf(item);
      if (!panel || current === item) return;

      closeAll(item);
      panel.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      current = item;

      /* Add .is-open a frame later: closed panel is display:none, no transition start (D-0334) */
      if (reduce.matches) {
        panel.classList.add('is-open');
      } else {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => panel.classList.add('is-open'));
        });
      }

      position(item, panel);
    };

    const position = (item, panel) => {
      panel.style.left = '';
      const wrap = nav.closest('.header') || nav;
      const wrapRect = wrap.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();

      let left = 0;
      const wantedRight = itemRect.left + panelRect.width;
      const limit = wrapRect.right;

      if (wantedRight > limit) left = limit - wantedRight;

      if (itemRect.left + left < wrapRect.left) left = wrapRect.left - itemRect.left;

      panel.style.left = Math.round(left) + 'px';
    };

    items.forEach((item) => {
      const trigger = triggerOf(item);

      item.addEventListener('pointerenter', (event) => {
        /* Skip touch: pointerenter fires on finger-down and pointerleave may never come (D-0339) */
        if (event.pointerType === 'touch') return;
        clearTimers();
        openTimer = window.setTimeout(() => open(item), OPEN_MS);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        clearTimers();
        closeTimer = window.setTimeout(() => close(item), CLOSE_MS);
      });

      /* Mouse clicks must not toggle; detail 0 is keyboard, which still toggles (D-0340) */
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          clearTimers();

          if (hoverMQ.matches && event.detail > 0) {
            if (current !== item) open(item);
            return;
          }

          if (current === item) close(item);
          else open(item);
        });
      }
    });

    nav.addEventListener('focusin', (event) => {
      const item = event.target.closest('.drb-nav__item--has-panel');
      clearTimers();
      if (item) open(item);
      else closeAll(null);
    });

    nav.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!nav.contains(document.activeElement)) closeAll(null);
      }, 0);
    });

    nav.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !current) return;
      const item = current;
      const trigger = triggerOf(item);
      close(item);
      if (trigger) trigger.focus();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!current) return;
      if (nav.contains(event.target)) return;
      clearTimers();
      closeAll(null);
    });

    window.addEventListener('resize', () => {
      if (!current) return;
      closeAll(null);
    });
  });
})();
